import { useEffect, useState } from 'react';
import Transform from '../../components/TransForm/Transform';
import StyledTable from '../../components/table-component/StyledTable';
import { useDispatch, useSelector } from 'react-redux';
import { createHotel, deleteHotel, fetchHotels, updateHotel } from '../../data/slices/hotelSlice';
import Hotel from '../../data/schemas/hotel';
import { notify } from '../../settings/toastSetting';
import { Dialog, Box, Paper, Typography } from '@mui/material';
import { Add, Hotel as HotelIcon } from '@mui/icons-material';
import { output, sortByProp, COLORS } from '../../settings/themeSettings';
import PageHeader from '../../components/layout/PageHeader';
import useIsAdmin from '../../hooks/useIsAdmin';

const HotelPage = (props) => {
    const { hotels } = useSelector((state) => state.hotels);
    const dispatch = useDispatch();
    const isAdmin = useIsAdmin();
    const [hotel, setHotel] = useState(null);
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setHotel(null);
    }

    const addHotel = (data, cb) => {
        handleClose();
        if (data.id) {
            updateHotel(data, (err) => output(err), (resp) => {
                cb();
                notify("L'hôtel a été enregistré avec succès !");
                dispatch(fetchHotels());
            });
            return;
        }
        createHotel(data, (err) => output(err), (resp) => {
            cb();
            notify("L'hôtel a été ajouté avec succès !");
            dispatch(fetchHotels());
        })
    }

    const onHotelSelected = (id) => {
        setHotel(hotels.find((h) => h.id === id));
        setOpen(true);
    }

    const onDelete = (id) => {
        handleClose();
        deleteHotel(id, (err) => output(err), (resp) => {
            setHotel(null);
            notify("L'hôtel a bien été supprimé !");
            dispatch(fetchHotels());
        });
    }

    useEffect(() => {
        dispatch(fetchHotels());
    }, [dispatch]);

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#f8fafc', minHeight: '100vh' }}>
            <PageHeader 
                title="Gestion des Hôtels"
                subtitle="Gérez vos partenaires hôteliers et leurs tarifs négociés"
                icon={HotelIcon}
                breadcrumbs={[
                    { label: 'Paramètres', path: '/parametres' },
                    { label: 'Hôtels', path: '/parametres/hotels' }
                ]}
                actions={isAdmin ? [
                    { 
                        label: 'Ajouter un hôtel', 
                        icon: <Add />, 
                        onClick: () => { setHotel(null); setOpen(true); },
                        color: 'primary'
                    }
                ] : []}
            />

            <Paper elevation={0} sx={{ 
                borderRadius: '16px', 
                overflow: 'hidden', 
                border: '1px solid',
                borderColor: COLORS.gray[200],
                bgcolor: 'white'
            }}>
                <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: COLORS.gray[100], bgcolor: COLORS.gray[50] }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: COLORS.secondary, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Liste des établissements ({hotels.length})
                    </Typography>
                </Box>
                
                <StyledTable
                    rows={[...hotels].sort((a,b) => sortByProp(a, b, 'nom'))}
                    head={Object.keys(new Hotel())}
                    onOptionClicked={onHotelSelected}
                />
            </Paper>

            <Dialog 
                open={open} 
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: { borderRadius: '20px', p: 1 }
                }}
            >
                <Transform
                    onSubmit={addHotel}
                    mandatories={["nom", "telephone", "code", "courriel", "adresse"]}
                    entity={new Hotel()}
                    toUpdate={hotel}
                    onDelete={isAdmin ? onDelete : undefined}
                    onCancel={handleClose}
                />
            </Dialog>
        </Box>
    );
}

export default HotelPage;
